import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Filter } from "~/features/filter";

import { contestTerritoriesFilterFields } from "./fields";

const ContestTerritoriesFilter = () => {
  const { t } = useTranslation();
  const fields = useMemo(() => contestTerritoriesFilterFields(t), [t]);

  return <Filter.Root fields={fields} alwaysShow columns={4} />;
};

export default ContestTerritoriesFilter;
